<script setup>
/*
  Componente para mostrar un popover al hacer click en un elemento.
  Hacemos el <div @click.stop="mostrar = true"> porque si no al hacer
  click no hace el stopPropagation y se nos abre el enlace de los links
  o lo que haya detrás:
  https://github.com/Akryum/floating-vue/issues/856
*/
import { useVModel } from '@vueuse/core';

const props = defineProps({
  disabled: { type: Boolean, default: false },
  show: { type: Boolean, default: null },
  posicion: { type: String, default: 'right' },
  triggers: { type: [String, Array], default: () => ['click'] },
  autoHide: { type: [Boolean, Function], default: true },
});

const emits = defineEmits(['update:show']);

const mostrar = useVModel(props, 'show', emits);
</script>

<template>
  <div class="cifra-popover-wrapper" @click.stop="mostrar = true">
    <VMenu
      v-model:shown="mostrar"
      :disabled="disabled"
      :triggers="triggers"
      :hide-triggers="triggers"
      :placement="posicion"
      popper-class="cifra-popover"
      :distance="14"
      :popper-hide-triggers="[]"
      :auto-hide="autoHide"
      :delay="0"
    >
      <slot></slot>
      <template #popper>
        <span v-close-popper class="close m-r-xs">
          <span class="text-12x">&times;</span>
        </span>
        <slot name="contenido"></slot>
      </template>
    </VMenu>
  </div>
</template>

<style lang="scss" scoped>
.cifra-popover-wrapper {
  // Inline porque si no nos sale el popover a la derecha del todo de la línea
  // en vez de a la derecha del contenido
  display: inline-table;
}
</style>

<style lang="scss">
.cifra-popover.v-popper--theme-menu .v-popper__inner {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
}
</style>
